$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  customAosAnimations();
});

$(window).load(function () {
  // ---
});

// --------------------------------
// Helpers
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-bar"></span>');
  });

  $('.header .mobile-nav-toggle').attr('tabindex', '0');
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// Adding lazy load aos on contents

function customAosAnimations() {
  let windowSize = window.innerWidth;

  $('.tier-3-container .inner-container-tier-b').attr({
    'data-aos': 'fade-left',
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '800',
    'data-aos-once': 'true',
    'data-aos-offset': windowSize <= 1050 ? '-10' : '-20',
  });
}
